<template>
  <input
    type="text"
    v-mask="timeMask"
    :value="value"
    @input="$emit('input', $event.target.value)"
    @keyup.enter="$emit('enter')"
    @blur="$emit('blur')"
  />
</template>
<script>
function timeMask(value) {
  const hours = [/[0-2]/, value.charAt(0) === "2" ? /[0-3]/ : /[0-9]/];
  const minutes = [/[0-5]/, /[0-9]/];
  return value.length > 2 ? [...hours, ":", ...minutes] : hours;
}
export default {
  props: {
    value: String,
  },
  data() {
    return {
      timeMask: timeMask,
    };
  },
  methods: {},
};
</script>
<style scoped>
input {
  min-width: 60px;
  max-width: 60px;
  display: inline-block;
  text-align: center;
}
</style>
